const GET_EVENT_CSV_REQUESTED = "GET_EVENT_CSV_REQUESTED"
const GET_EVENT_CSV_SUCCEEDED = "GET_EVENT_CSV_SUCCEEDED"
const GET_EVENT_CSV_FAILED = "GET_EVENT_CSV_FAILED"

export {
  GET_EVENT_CSV_REQUESTED, GET_EVENT_CSV_SUCCEEDED, GET_EVENT_CSV_FAILED}